import Typography from '@mui/material/Typography'

const PaddedText = ({ children, typographyProps }) => (
  <Typography padding={2} textAlign="center" {...typographyProps}>
    {children}
  </Typography>
)

export default PaddedText
